import { useBirthday } from 'components/features/target-achievement-support/utils/birthday';
import { useModal } from 'hooks/useModal';
import React from 'react';
import { BirthDayRegisterModal } from './BirthDayRegisterModal';

export const NotFoundBirthday = (): React.ReactElement => {
  const [isShowBirthDayRegisterModal, { hideModal }] = useModal(true);
  const { refetchBirthday, setBirthday } = useBirthday();

  return (
    <>
      <BirthDayRegisterModal
        {...{
          isShow: isShowBirthDayRegisterModal,
          close: () => {
            hideModal();
            refetchBirthday();
          },
          register: setBirthday,
        }}
      />
    </>
  );
};
